import background from './img/background.svg';

const style = {
  unauthorizedLayout: {
    height: '100vh',
    backgroundColor: '#FFF',
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  unauthorizedLayout__formWrapper: {
    backgroundColor: '#FFF',
    minWidth: '260px',
    maxWidth: 'fit-content',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.14)',
    padding: '25px 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formWrapper__logoWrapper: {
    padding: '20px 0',
    width: '100%',
    maxWidth: '340px',
    height: 'auto',
  },
  formWrapper__logo: {
    width: '100%',
  },
};

export default style;
